import baseAPI from "@/http";

const base = "api/selo/criterio5";
export const criterio5API = {
  configuracao: () => baseAPI.get(`${base}/configuracao`),
  obter: id => baseAPI.get(`${base}/${id}`),
  salvar: (id, dados) => baseAPI.put(`${base}/${id}/rascunho`, dados),
  previa: (id, dados) => baseAPI.post(`${base}/${id}/previa`, dados),
  finalizar: (id, dados) => baseAPI.post(`${base}/${id}/finalizar`, dados),
  reverter: (id, motivo) => baseAPI.post(`${base}/${id}/reverter`, { motivo }),
};
